import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { LANGUAGES } from "../i18n";
import { localApi } from "../lib/localApi";

/** Sélecteur FR / EN — mémorisé dans le navigateur et, si connecté, sur le compte. */
export function LanguageToggle({ variant = "light", loggedIn = false, className = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "fr").slice(0, 2);
  const change = (code) => {
    if (code === current) return;
    i18n.changeLanguage(code);
    if (loggedIn) localApi.post("/auth/language", { language: code }).catch(() => {});
  };
  const dark = variant === "dark";
  return (
    <div className={`inline-flex items-center gap-1 rounded-lg p-0.5 ${dark ? "bg-white/5" : "bg-secondary"} ${className}`} role="group" aria-label="Langue" data-testid="language-toggle">
      <Languages className={`h-3.5 w-3.5 ml-1.5 ${dark ? "text-slate-400" : "text-muted-foreground"}`} />
      {LANGUAGES.map((l) => (
        <button key={l.code} type="button" onClick={() => change(l.code)} data-testid={`lang-${l.code}`} aria-pressed={current === l.code} title={l.label}
          className={`rounded-md px-2 py-1 text-[11px] font-semibold uppercase tracking-wide transition-colors ${current === l.code ? (dark ? "bg-brass text-[#0f172a]" : "bg-[#0f172a] text-white") : (dark ? "text-slate-400 hover:text-white" : "text-muted-foreground hover:text-foreground")}`}>
          {l.short}
        </button>
      ))}
    </div>
  );
}
